import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import store from './store.jsx';
import ApplicationPage from "pages/application";
import AuthService from './services/auth.service';
import AuthInterceptor from './services/auth.interceptor';
import styles from 'pages/application/application.module.scss';

import _ from 'lodash';

AuthInterceptor();

ReactDOM.render(
  <Provider store={store}>
    <ApplicationPage />
  </Provider>,
  document.getElementById('root')
);